export default __webpack_public_path__ + "static/media/question2-mobile.9d4f5eed.svg";